<template>
  <v-container class="px-4 grid-list-md">
    <v-row>
      <v-col align="start" md="5">
        <h1>{{ page || title }}</h1>
      </v-col>
      <v-spacer/>
      <v-col md="5">
        <div align="end">
          <v-btn v-on:click="generatorAction('new')" rounded>
              Create {{ page || title }}
          </v-btn>
        </div>
      </v-col>
    </v-row>
     <v-row>
      <v-col>
        <v-card>
          <v-layout>
            <v-flex xs12 sm12 md12>
              <v-text-field
                class="mb-2 input-search-email"
                v-model="search"
                append-icon="mdi-email-search-outline"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="desserts"
            :items-per-page="15"
            item-key="list_id"
            show-select
            calculate-widths
            class="elevation-1"
          >
            <template v-slot:item.list_name="props">
              <a v-on:click="$router.push('contactGroup/subscriber')">
                {{ props.item.list_name }}
              </a>
              <p class="mb-0">Created: {{ props.item.created }}</p>
            </template>
            <template v-slot:item.action="props">
              <div>
                <v-menu>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      small
                      class="mr-2"
                    >
                      mdi-dots-vertical
                    </v-icon>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(action, key) in dropdown_items"
                      :key="key"
                      v-on:click="generatorAction(action.value, props.item.list_id)"
                    >
                      <v-list-item-title class="text-left">{{ action.name }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <Dialog
        :listName="listName"
        :openDialog="dialog"
        :closemodal="closemodal"
        :okcallback="
          onAction === 'edit'
            ? saveEditName
            : onAction === 'add'
              ? addListsName
              : deleteListsName
          "
        :btnSaveText="onAction === 'delete' ? 'confirm' : 'Save'"
        :btnCloseText="onAction === 'delete' ? 'cancel' : 'Close'"
        :loading="loading"
        :headline="headline"
        :pretext="pretext"
        :onAction="onAction"
        :icon="icon"
      ></Dialog>
      <v-snackbar
        v-model="snackbar"
        :top="true"
        :right="true"
        :color="snackbarType"
      >
        {{ snackbarText }}
      </v-snackbar>
      <AddContact
        :addContactDig="addContactDig"
      ></AddContact>
    </v-row>
  </v-container>
</template>

<script>
import _ from 'lodash'
import Dialog from '@/components/lists/Dialog.vue'
import AddContact from '@/components/lists/AddContact.vue'
export default {
  components: {
    Dialog, AddContact,
  },
  data() {
    return {
      search: '',
      headline: '',
      onAction: '',
      pretext: '',
      snackbar: false,
      icon: false,
      snackbarText: '',
      snackbarType: '',
      dialog: false,
      loading: false,
      addContactDig: false,
      page: 'Contacts Groups',
      selected: [],
      listName: '',
      dropdown_items: [
        {name: 'Add Contact', value: 'add'},
        {name: 'Edit Group Name', value: 'edit'},
        {name: 'Custom Fields', value: 'custom'},
        {name: 'Delete', value: 'delete'},
        {name: 'Export', value: 'export'},
      ],
      headers: [
          { text: 'List name', align: 'left', value: 'list_name' },
          { text: 'Subscriber', value: 'total_subscriber' },
          { text: 'Bounce', value: 'total_bounce' },
          { text: 'Unsubscribe', value: 'total_unsubscribe' },
          { text: 'Spam', value: 'total_spam' },
          { text: 'Open rate', value: 'open_rate' },
          { text: 'Click rate', value: 'click_rate' },
          { text: 'Action', align: 'center', sortable: false, value: 'action' },
      ],
      desserts: [
        {
          list_id: 'XL55660158',
          list_name: 'New Customer',
          total_subscriber: 159,
          total_bounce: 16,
          total_unsubscribe: 4,
          total_spam: 4,
          open_rate: '80%',
          click_rate: '45%',
          created: '7 Aug 2019',
        },
        {
          list_id: 'XL55660159',
          list_name: 'Event Ice cream sandwich',
          total_subscriber: 237,
          total_bounce: 9,
          total_unsubscribe: 7,
          total_spam: 2,
          open_rate: '75%',
          click_rate: '30%',
          created: '9 Aug 2019',
        },
        {
          list_id: 'XL55660160',
          list_name: 'Event Promotion New Year',
          total_subscriber: 225,
          total_bounce: 1,
          total_unsubscribe: 2,
          total_spam: 0,
          open_rate: '95%',
          click_rate: '60%',
          created: '1 Aug 2019',
        },
      ],
    }
  },
  methods: {
    async generatorAction(action, id) {
      const thizid = id
      this.icon = false
      if (action === 'new') {
        this.headline = 'Create group name'
        this.pretext  = 'A list contains your subscribers.'
        this.onAction = 'add'
        this.dialog = true
      } else if (action === 'add') {
        this.addContactDig = true
      } else if (action === 'edit') {
        this.headline = 'Edit group name'
        this.pretext = 'A list contains your subscribers.'
        this.onAction = 'edit'
        this.lists = await _.find(
          this.desserts, (o) => {
            return o.list_id === thizid
          },
        )
        this.listName = this.lists.list_name
        this.dialog = true
      } else if (action === 'delete') {
        this.headline = 'Are you sure?'
        this.pretext = 'Are you sure that you want to delete?'
        this.onAction = 'delete'
        this.icon = true
        this.lists = await _.find(
          this.desserts, (e) => {
            return e.list_id === thizid
          },
        )
        this.dialog = true
      }
    },
    saveEditName() {
      this.loading = true
      setTimeout(() => {
        this.snackbarText = 'Save data edit success.'
        this.snackbarType = 'success'
        this.snackbar = true
        this.loading = false
        this.dialog = false
      }, 500)
      return true
    },
    addListsName() {
      this.loading = true
      setTimeout(() => {
        this.snackbarText = 'Create new contact group success.'
        this.snackbarType = 'success'
        this.snackbar = true
        this.loading = false
        this.dialog = false
      }, 500)
      return true
    },
    deleteListsName() {
      try {
        const thizid  = this.lists.list_id
        this.desserts = _.remove(this.desserts, (e) => {
          return e.list_id !== thizid
        })
        this.snackbarText = 'Delete contact group ' + this.lists.list_name + ' success.'
        this.snackbarType = 'success'
        this.snackbar = true
        this.dialog = false
      } catch {
        throw new Error('can\'t connect to service.')
      }
    },
    closemodal() {
      this.dialog = false
    },
  },
}
</script>
